
export { useSocialFeedPartnersQuery } from "/home/runner/work/capsicum/capsicum/libs/features/feeds/shared/src/data-access/queries/useSocialFeedPartnersQuery.ts"